import { combineReducers } from "redux"
import { screening } from "./screeningReducer"

const screeningReducers = combineReducers({
  screening
})

export default screeningReducers
